// Where a logged-in user of any role lands / gets bounced back to: the one front door, `/`. RootRoute in
// App.js shows each role its own home from there (customers and agents in place; staff to /dashboard;
// technicians to /technical). Kept as a function so call sites still read as "home for this role".
// (Before: /portal, /agent, /technical or /dashboard depending on role. Those addresses still work.)
// Shared between App.js (route guards) and LoginPage.js (the login form does not know the role in
// advance: the backend resolves it from mobile + password, see backend/src/routes/auth.js POST /login).
export const homeForRole = () => '/';

export default homeForRole;
